import { useTranslation } from 'react-i18next';

import { IngredientTabProps } from 'components/desktop/Ingredient/IngredientComponent';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import ItemListEditor from 'components/desktop/_general/ItemListEditor/ItemListEditor';
import * as AllergenListStore from 'types/_general/Store/AllergenList';

export const IngredientAllergensCard = ({
	state,
	handlers,
	data,
}: IngredientTabProps): JSX.Element => {
	const { t } = useTranslation();
	return (
		<FoldableCard
			defaultOpen={true}
			dataComponentType="ingredient-allergens-card"
			title={t('_general:ALLERGENS')}
			info={'_general:ALLERGEN_INFO_TOOLTIP'}
			content={
				<div className="card-body">
					<ItemListEditor
						allItems={AllergenListStore.mapToUniqIdList(data.allergens)}
						itemIds={state.allergenIds}
						setItemIds={handlers.setAllergenIds}
						noItemsMessage={t('_general:NO_ALLERGENS')}
					/>
				</div>
			}
		/>
	);
};
